"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _hooks = require("../../../../../CampaignSettings/hooks");

var _messaging = require("../../constants/messaging.types");

var _user = require("../../../../../Shared/store/user/user.selectors");

var _IntegrationConnectionWarning = _interopRequireDefault(require("../../../../components/IntegrationConnection/IntegrationConnectionWarning"));

var _SelectTeamMember = require("../../../../../Shared/Teams/components/SelectTeamMember");

var _members = require("../../../../../Shared/Teams/store/members/members.helpers");

var styles = {
  title: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '18px',
    color: 'text.main'
  },
  meetingOwner: {
    mt: 3
  },
  attendee: {
    mt: 2,
    ml: 3
  }
};

var MeetingHostsController = function MeetingHostsController(_ref) {
  var _campaign$team, _attendeeIdsValue$;

  var control = _ref.control,
      campaign = _ref.campaign,
      isMessagingPending = _ref.isMessagingPending,
      isGiftsCreatePending = _ref.isGiftsCreatePending;
  var teamId = campaign === null || campaign === void 0 ? void 0 : (_campaign$team = campaign.team) === null || _campaign$team === void 0 ? void 0 : _campaign$team.id;
  var currentUserId = (0, _reactRedux.useSelector)(_user.getUserId);

  var _useTeamMembers = (0, _hooks.useTeamMembers)(teamId),
      useIds = _useTeamMembers.useIds,
      isTeamMembersPending = _useTeamMembers.isPending;

  var teamMembersIds = useIds();

  var getTeamMemberLabel = function getTeamMemberLabel(teamMember) {
    var mySelfPrefix = teamMember.id === currentUserId ? ' (myself)' : '';
    return "".concat(teamMember.firstName, " ").concat(teamMember.lastName).concat(mySelfPrefix);
  };

  var ownerIdFieldName = "".concat(_messaging.MessagingDataFields.MeetingHosts, ".").concat(_messaging.MeetingHostsFields.OwnerId);
  var attendeeIdsFieldName = "".concat(_messaging.MessagingDataFields.MeetingHosts, ".").concat(_messaging.MeetingHostsFields.AttendeeIds);
  var isAttendeeEnabledFieldName = "".concat(_messaging.MessagingDataFields.MeetingHosts, ".").concat(_messaging.MeetingHostsFields.IsAttendeeEnabled);
  var isFieldsDisabled = isMessagingPending || isGiftsCreatePending || isTeamMembersPending;

  var _useController = (0, _reactHookForm.useController)({
    control,
    name: ownerIdFieldName
  }),
      _useController$field = _useController.field,
      ownerIdValue = _useController$field.value,
      ownerIdOnChange = _useController$field.onChange,
      ownerIdError = _useController.fieldState.error;

  var _useController2 = (0, _reactHookForm.useController)({
    control,
    name: attendeeIdsFieldName
  }),
      _useController2$field = _useController2.field,
      attendeeIdsValue = _useController2$field.value,
      attendeeIdsOnChange = _useController2$field.onChange,
      attendeeIdsError = _useController2.fieldState.error;

  var _useController3 = (0, _reactHookForm.useController)({
    control,
    name: isAttendeeEnabledFieldName
  }),
      _useController3$field = _useController3.field,
      isAttendeeEnabledValue = _useController3$field.value,
      isAttendeeEnabledOnChange = _useController3$field.onChange;

  var isAttendeeAvailable = teamMembersIds.length > 1;
  var sortTeamMembers = (0, _react.useMemo)(function () {
    return (0, _members.makeSortTeamMembers)(currentUserId);
  }, [currentUserId]);
  var filterOwners = (0, _react.useCallback)(function (owner) {
    return owner.id !== attendeeIdsValue[0];
  }, [attendeeIdsValue]);
  var filterAttendees = (0, _react.useCallback)(function (owner) {
    return owner.id !== ownerIdValue;
  }, [ownerIdValue]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.title
  }, "This campaign requires booking a meeting in order to redeem a gift. Whose calendar should we book?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_SelectTeamMember.SelectTeamMember, {
    name: _messaging.MeetingHostsFields.OwnerId,
    teamId: teamId,
    fullWidth: true,
    nullable: true,
    label: "Select meeting owner",
    value: ownerIdValue,
    error: !!(ownerIdError !== null && ownerIdError !== void 0 && ownerIdError.message),
    helperText: ownerIdError === null || ownerIdError === void 0 ? void 0 : ownerIdError.message,
    disabled: isFieldsDisabled,
    renderOptionLabel: getTeamMemberLabel,
    onChange: ownerIdOnChange,
    sortOptions: sortTeamMembers,
    filterOptions: filterOwners
  })), /*#__PURE__*/_react.default.createElement(_IntegrationConnectionWarning.default, {
    teamId: teamId,
    sendAsId: ownerIdValue,
    my: 2
  }), isAttendeeAvailable && /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    disabled: isFieldsDisabled,
    "data-testid": "GiftingFlow.Message.MeetingHosts.IsAttendeeEnabled.FormControlLabel",
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      name: _messaging.MeetingHostsFields.IsAttendeeEnabled,
      checked: isAttendeeEnabledValue,
      onChange: function onChange(event, value) {
        isAttendeeEnabledOnChange(value);

        if (!value) {
          attendeeIdsOnChange([]);
        }
      },
      value: isAttendeeEnabledValue,
      color: "primary"
    }),
    label: "Copy a team member on the invitation"
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: isAttendeeAvailable && isAttendeeEnabledValue,
    unmountOnExit: true,
    sx: styles.attendee
  }, /*#__PURE__*/_react.default.createElement(_SelectTeamMember.SelectTeamMember, {
    name: _messaging.MeetingHostsFields.AttendeeIds,
    teamId: teamId,
    fullWidth: true,
    label: "Select meeting attendee",
    value: (_attendeeIdsValue$ = attendeeIdsValue[0]) !== null && _attendeeIdsValue$ !== void 0 ? _attendeeIdsValue$ : '',
    error: !!(attendeeIdsError !== null && attendeeIdsError !== void 0 && attendeeIdsError.message),
    helperText: attendeeIdsError === null || attendeeIdsError === void 0 ? void 0 : attendeeIdsError.message,
    disabled: isFieldsDisabled,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return attendeeIdsOnChange([value]);
    },
    sortOptions: sortTeamMembers,
    filterOptions: filterAttendees
  }))));
};

var _default = /*#__PURE__*/(0, _react.memo)(MeetingHostsController);

exports.default = _default;